// Sidebar akun Kasir Kafe (role 10): hanya layar kasir outletnya
export default [
  {
    component: 'CNavItem',
    name: 'Kasir',
    to: '/kafe/kasir',
    icon: 'cil-cart',
  },
]
